import { Link, Outlet, useLocation } from "react-router-dom";
import { cn } from "@/cn";

const HUB_TABS = [
  { path: "/goals", label: "Goals", match: (p: string) => p === "/goals" || p.startsWith("/goals/") },
  { path: "/plans", label: "Plans", match: (p: string) => p === "/plans" || p.startsWith("/plans/") },
  { path: "/work", label: "Work", match: (p: string) => p === "/work" || p.startsWith("/work/") },
] as const;

export function GoalsHubLayout() {
  const location = useLocation();

  return (
    <>
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-foreground">Goals</h1>
        <p className="text-muted-foreground">
          Outcomes, plans, and work that keep Career Moves on track.
        </p>
      </header>

      <div className="mb-6 flex gap-1 overflow-x-auto border-b border-border">
        {HUB_TABS.map((tab) => {
          const active = tab.match(location.pathname);
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={cn(
                "relative whitespace-nowrap px-4 py-2.5 text-sm font-medium transition",
                active
                  ? "text-foreground"
                  : "text-muted-foreground hover:text-foreground",
              )}
            >
              {tab.label}
              {active ? (
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-brand" />
              ) : null}
            </Link>
          );
        })}
      </div>

      <Outlet />
    </>
  );
}
